"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
exports.default = (function (transparent48v2) { return function (raw) {
    var virtual = transparent48v2.virtual;
    var _a = virtual.protocol, fields = _a.fields, cmds = _a.cmds;
    var cmdId = utils_1.hexToDec(raw.slice(8, 10));
    raw = raw.slice(10, -2);
    var cmd = cmds[cmdId];
    if (!cmd) {
        return;
    }
    var data = cmd.fields.reduce(function (val, field) {
        var _a = fields[field], dataLength = _a.dataLength, dataType = _a.dataType;
        if (dataType === 'NUMBER') {
            val[field] = utils_1.hexToDec(raw.slice(0, dataLength * 2));
        }
        else if (dataType === 'STRING') {
            var codes = utils_1.splitByLength(raw.slice(0, dataLength * 2))
                .map(function (val) { return utils_1.hexToDec(val); })
                .filter(function (val) { return val; });
            val[field] = utils_1.UTF8BytesToRaw(codes);
        }
        raw = raw.slice(dataLength * 2);
        return val;
    }, { cmdId: cmdId });
    // 添加关联的上报帧到[[QUEUE]]
    var associateProtocol = cmds[cmdId].associateProtocol;
    associateProtocol.forEach(function (cmdId) { return virtual['[[QUEUE]]'].add(cmdId); });
    // 更新设备状态
    virtual.setState(data);
    // 发送队列中的上报帧
    virtual['[[QUEUE]]'].forEach(function (cmdId) {
        var fields = cmds[cmdId].fields;
        var state = { cmdId: cmdId };
        fields.forEach(function (field) {
            state[field] = virtual.state[field];
        });
        // 模拟网络延迟
        setTimeout(function () {
            // 上报帧
            virtual.send('devSend', { data: state });
        }, virtual.options.delay);
    });
    virtual['[[QUEUE]]'].clear();
}; });



// WEBPACK FOOTER //
// ./src/transparent48v2/decode/7.ts